"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[767],{

/***/ 9024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7280);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6631);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8757);





function RateBadge(param) {
    let { rate , textClassName  } = param;
    const { score , count  } = rate || {};
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("common");
    return count && count > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex items-center space-x-1 text-sm", textClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdStar */ .MVI, {
                className: "relative -top-[1px] w-4 h-4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: score
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: t("global.noreview")
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(RateBadge));


/***/ }),

/***/ 9767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ List_providers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/lodash-es/chunk.js + 5 modules
var chunk = __webpack_require__(3978);
// EXTERNAL MODULE: ./hooks/useFetch.ts + 1 modules
var useFetch = __webpack_require__(9350);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(7832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/BookNow/BookNow.tsx
var BookNow = __webpack_require__(6562);
// EXTERNAL MODULE: ./components/Cards/Card.tsx
var Card = __webpack_require__(2132);
// EXTERNAL MODULE: ./components/Badges/Rate.badge.tsx
var Rate_badge = __webpack_require__(9024);
// EXTERNAL MODULE: ./hooks/useReadmore.ts + 1 modules
var useReadmore = __webpack_require__(1123);
// EXTERNAL MODULE: ./utils/utils.ts
var utils = __webpack_require__(8728);
;// CONCATENATED MODULE: ./components/Provider/Provider.card.tsx









const DOMAIN_URL = "https://www.yocale.com";
const ProviderCard = (param)=>{
    let { id , title , description , rate , imageUrl , unavailableItems  } = param;
    const unavailableItem = (0,react.useMemo)(()=>{
        return unavailableItems === null || unavailableItems === void 0 ? void 0 : unavailableItems.reduce((obj, cur)=>({
                ...obj,
                [cur]: true
            }), {});
    }, [
        unavailableItems
    ]);
    const [truncated, hasLimit] = (0,useReadmore/* default */.Z)(description || "", 320);
    const { data: businessProfile  } = (0,useFetch/* useBusinessProfile */.jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data.widget;
    const providerLink = "".concat(DOMAIN_URL, "/widget/").concat(widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.uniqueIdentifier, "/provider/").concat((0,utils/* toSearchEngineFriendlyWords */.Eh)(title), "/").concat(id);
    const isImageHidden = unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.image;
    const isRateHidden = unavailableItem === null || unavailableItem === void 0 ? void 0 : unavailableItem.rate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex gap-4 sm:gap-8 items-start flex-col sm:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: providerLink,
                            target: "_blank",
                            className: "hover:text-primary-500",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "font-medium text-lg mb-1",
                                children: title
                            })
                        }),
                        !isRateHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)(Rate_badge/* default */.Z, {
                            textClassName: "text-primary-500",
                            rate: rate
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-sm mt-2 text-[#46474a] leading-6 break-word pre-line",
                            children: [
                                truncated,
                                hasLimit && " ..."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full sm:w-auto min-w-[9rem] max-w-none sm:max-w-[9rem] flex-none flex flex-col space-y-3 justify-end sm:pl-4",
                    children: [
                        !isImageHidden && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative aspect-[1.6] sm:aspect-[1.18] overflow-hidden",
                            children: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "w-full h-full bg-gray-200 rounded-lg object-cover select-none",
                                src: imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url,
                                alt: (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.alt) || title,
                                width: 300,
                                height: 254,
                                quality: 90,
                                loading: "lazy"
                            }) || /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 rounded-lg flex items-center justify-center bg-gray-200 text-gray-500",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    className: "w-6 h-6",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 32 32",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fill: "currentColor",
                                        d: "M11.8 18.75c-3.276 0-9.8 1.839-9.8 5.5V27h19.6v-2.75c0-3.661-6.524-5.5-9.8-5.5Zm-6.524 5.107a12.407 12.407 0 0 1 6.524-1.964c2.315.033 4.575.713 6.524 1.964H5.276ZM11.8 16c2.7 0 4.9-2.467 4.9-5.5S14.5 5 11.8 5s-4.9 2.467-4.9 5.5S9.1 16 11.8 16Zm0-7.857a2.237 2.237 0 0 1 2.1 2.357 2.237 2.237 0 0 1-2.1 2.357A2.237 2.237 0 0 1 9.7 10.5a2.237 2.237 0 0 1 2.1-2.357Zm9.856 10.7A6.792 6.792 0 0 1 24.4 24.25V27H30v-2.75c0-3.174-4.9-4.982-8.344-5.407ZM20.2 16c2.7 0 4.9-2.467 4.9-5.5S22.9 5 20.2 5a4.4 4.4 0 0 0-2.1.55 9.45 9.45 0 0 1 0 9.9 4.401 4.401 0 0 0 2.1.55Z"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BookNow/* default */.Z, {
                            uniqueIdentifier: widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.uniqueIdentifier,
                            type: "provider",
                            id: id,
                            buttonWide: true
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Provider_card = (ProviderCard);

// EXTERNAL MODULE: ./components/Loading/Loading.tsx
var Loading = __webpack_require__(4737);
// EXTERNAL MODULE: ./hooks/useVirtualized.ts + 1 modules
var useVirtualized = __webpack_require__(1764);
;// CONCATENATED MODULE: ./containers/Providers/List.providers.tsx







function ProvidersList(param) {
    let {} = param;
    const { data: businessProfile  } = (0,useFetch/* useBusinessProfile */.jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data;
    const unavailableItems = widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.widget.settings.provider.unavailableItems;
    const { data , error , fetchNextPage , isFetching , isFetchingNextPage , status  } = (0,useFetch/* useProvider */.yL)(widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.key);
    const providers = (0,react.useMemo)(()=>data ? data.pages.flatMap((page)=>page.items) : [], [
        data
    ]);
    const chunkyData = (0,react.useMemo)(()=>(0,chunk/* default */.Z)(providers, 2), [
        providers
    ]);
    const lastPage = data === null || data === void 0 ? void 0 : data.pages[data.pageParams.length - 1];
    const hasNextPage = (lastPage === null || lastPage === void 0 ? void 0 : lastPage.hasNext) || false;
    const { parentRef , rowVirtualizer , items , totalSize  } = (0,useVirtualized/* default */.Z)({
        fetchNextPage,
        isFetchingNextPage,
        hasNextPage,
        length: chunkyData.length
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            status === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : status === "error" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    "Error: ",
                    error.message
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: parentRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full",
                    style: {
                        height: totalSize
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 w-full",
                        style: {
                            transform: "translateY(".concat(items[0].start - rowVirtualizer.options.scrollMargin, "px)")
                        },
                        children: items.map((virtualRow)=>{
                            const isLoaderRow = virtualRow.index > chunkyData.length - 1;
                            const row = chunkyData[virtualRow.index];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "data-index": virtualRow.index,
                                ref: rowVirtualizer.measureElement,
                                className: "grid grid-cols-1 lg:grid-cols-2 gap-4 pb-4",
                                children: isLoaderRow ? hasNextPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : "Nothing more to load" : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: row.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Provider_card, {
                                            id: item.id,
                                            description: item.description,
                                            rate: item.rate,
                                            title: item.name,
                                            imageUrl: item.image,
                                            unavailableItems: unavailableItems
                                        }, item.id))
                                })
                            }, virtualRow.key);
                        })
                    })
                })
            }),
            isFetching && !isFetchingNextPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : null
        ]
    });
}
/* harmony default export */ var List_providers = (/*#__PURE__*/(0,react.memo)(ProvidersList));


/***/ })

}]);